export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  meetings: [],
  years: [],
  entity: 'meeting',
  entities: 'meetings',
  prefixRouter: 'dweller.meetings'
})



// WEBPACK FOOTER //
// ./src/app/tenant/meeting/resources/data.js